import { LitElement, html, css } from "lit-element";

// language=CSS
export const InputRadioboxStyle = css`
	:host {
		display: flex;
		width: 100%;
	}

	.options {
		display: var(--sw-input-radiobox-options-display, flex);
	}

	:host label > input[type="checkbox"],
	:host label > input[type="radio"] {
		display: none;
	}
	:host legend,
	:host label {
		display: block;
		font-size: 14px;
		position: relative;
		border-radius: 2px;
	}

	:host label {
		padding: var(--sw-input-radiobox-option-padding, 0);
		margin: var(--sw-input-radiobox-option-margin, 0);
	}

	:host legend {
		-ms-flex: 1 1 0.000000001px;
		-webkit-flex: 1;
		flex: 1;
		-webkit-flex-basis: 0.000000001px;
		flex-basis: 0.000000001px;

		padding: var(--sw-input-radiobox-legend-padding, 5px 20px 5px 40px);
		margin: var(--sw-input-radiobox-legend-margin, 0);
		height: 20px;
		display: block;
		font-weight: bold;
	}
	:host label > input-md-decorator {
		-ms-flex: 1 1 0.000000001px;
		-webkit-flex: 1;
		flex: 1;
		-webkit-flex-basis: 0.000000001px;
		flex-basis: 0.000000001px;
		padding: 5px 20px 5px 40px;
		height: 20px;
		display: block;
		cursor: pointer;
	}

	:host input[aria-invalid="true"] + input-md-decorator {
		color: var(--app-red);
	}

	:host label > input[type="checkbox"] + input-md-decorator::after,
	:host label > input[type="radio"] + input-md-decorator::after {
		font-weight: bold;
		content: "";
		display: block;
		position: absolute;

		left: 0;
		top: 5px;
		height: 16px;
		width: 16px;

		transition: opacity 0.1s;
		will-change: opacity;

		border: 3px solid var(--app-accent);
		border-radius: 3px;
	}
	:host label > input:disabled + input-md-decorator::after {
		border: 3px solid var(--app-lightgrey);
	}

	:host input:disabled + input-md-decorator {
		color: var(--app-lightgrey);
	}

	:host label > input[type="checkbox"]:checked + input-md-decorator,
	:host label > input[type="radio"]:checked + input-md-decorator {
		color: var(--app-primary);
	}

	:host label > input[type="checkbox"]:checked + input-md-decorator::after,
	:host label > input[type="radio"]:checked + input-md-decorator::after {
		background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23FFFFFF' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/%3E%3C/svg%3E");
		background-position: center;
		background-size: 16px;
		background-color: var(--app-accent);
		border: 3px solid var(--app-accent);
	}
`;

export class InputRadiobox extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			type: { type: String },
			cast: { type: String },
			checked: { type: Boolean },
			required: { type: Boolean },
			options: { type: Array },
			disabledOptions: { type: Object },
			limit: { type: Number }
		};
	}

	static get styles() {
		return InputRadioboxStyle;
	}

	constructor() {
		super();
		this.type = "radio";
		this.disabledOptions = {};
	}
	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
	}

	render() {
		return html`
			<div class="options">
				${this.options &&
					this.options.map((option, index) => {
						if (!option) {
							return;
						}
						return html`
							<label @click="${this.onChange}">
								<input
									type="${this.type}"
									data-cast="${this.cast ? this.cast : "radio"}"
									name="${this.name}"
									value="${option.value}"
									?disabled="${option.disabled ? option.disabled : this.disabledOptions[option.id]}"
									?required="${this.required}"
									?checked="${option.checked}"
								/>
								<input-md-decorator>${option.label}</input-md-decorator>
							</label>
						`;
					})}
			</div>
			<legend>${this.label}${this.required ? "*" : ""}</legend>
		`;
	}

	onChange() {
		const inputs = this.shadowRoot.querySelectorAll('[name="' + this.name + '"]:checked');
		if (inputs.length >= this.limit) {
			this.options.map(option => {
				const elm = this.shadowRoot.querySelector('[value="' + option.value + '"]');
				if (!elm.checked) {
					this.disabledOptions[option.id] = true;
				}
			});
			this.requestUpdate();
		} else {
			this.options.map(option => {
				this.disabledOptions[option.id] = option.disabled;
			});

			this.requestUpdate();
		}
	}
}

customElements.define("input-radiobox", InputRadiobox);
